const CODELESS_SESSION_STORAGE_CONVERSIONS_KEY = 'taboola-codeless-rules';

export const setNewConversionsSessionStorage = (conversions = []) => {
    sessionStorage.setItem(CODELESS_SESSION_STORAGE_CONVERSIONS_KEY, JSON.stringify(conversions));
};

export const getNewConversionsFromSessionStorage = () => {
    const conversions = sessionStorage.getItem(CODELESS_SESSION_STORAGE_CONVERSIONS_KEY);
    return conversions ? JSON.parse(conversions) : [];
};
